import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export const initialState = {
  isInitialized: false,
  isOpenNav: false,
  isAuth: false,
}

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setIsOpenNav(state, { payload }: PayloadAction<boolean>) {
      state.isOpenNav = payload
    },
    setIsInitialized(state) {
      state.isInitialized = true
    },
    setIsAuth(state, { payload }: PayloadAction<boolean>) {
      state.isAuth = payload
    },
  },
})

export type AppStateType = typeof initialState

export const {
  setIsOpenNav,
  setIsInitialized,
  setIsAuth,
} = appSlice.actions
export const appReducer = appSlice.reducer
